import { atom } from "recoil";
import { ocPersistAtom } from "oc/states/persist-atom";

export const firstApplyInTaxYearOrToWithDrawal = atom({
  key: "firstApplyInTaxYearOrToWithDrawal",
  default: "applyInTaxYear",
  effects_UNSTABLE: [ocPersistAtom],
});
